<template>
  <div>
    <template v-if="$apollo.loading">
      <loading/>
    </template>

    <template v-else>
      <h1 v-if="title" class="title is-size-4 is-size-5-mobile has-text-weight-extra-bold">{{ title }}</h1>

      <album-list v-bind:albums="albums"/>
    </template>
  </div>
</template>

<script>
  import Loading from '@/components/Loading'

  import AlbumList from '@/components/AlbumList'

  export default {
    name: 'Albums',
    components: {
      Loading,
      AlbumList
    },
    props: {
      title: {
        type: String,
        required: false
      },
      played: {
        required: false
      },
      orderBy: {
        type: String,
        required: false
      }
    },
    apollo: {
      albums: {
        query: require('@/graphql/Albums.gql'),
        variables () {
          return {
            played: this.played,
            orderBy: this.orderBy
          }
        }
      }
    }
  }
</script>
